module.exports = __webpack_public_path__ + "static/related-content-7dd6c56a4ca67d42363713627190c44f.png";